import type { StateContext } from '@ngxs/store';
import { Control } from 'commons';
import { produce } from 'immer';
import type { BatchChangeChannels, CreateVirtualChannel } from '../actions/sensortable.actions';
import type { MultiViewStateModel } from '../MultiViewStateModel';
import { getViewIndex } from '.';

export namespace ChannelHandlers {
  /**
   * Create a virtual channel
   * @param ctx state context
   * @param param1 action parameters
   */
  export function createVirtualChannel(ctx: StateContext<MultiViewStateModel>, { control }: CreateVirtualChannel) {
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        const viewIndex = getViewIndex(ctx);
        draft.views[viewIndex]?.sensorTable.push(new Control({ ...control, isVirtual: true }));
      })
    );
  }

  /**
   * Batch change channels
   * @param ctx state context
   * @param param1 action parameters
   */
  export function batchChangeChannels(ctx: StateContext<MultiViewStateModel>, { control: changedOptions, changeSetIds }: BatchChangeChannels) {
    ctx.setState(
      produce(ctx.getState(), (draft) => {
        const view = draft.views[getViewIndex(ctx)];

        view.sensorTable = view.sensorTable.map((control) => {
          if (changeSetIds?.includes(control.id) || !changeSetIds) {
            return { ...control, ...changedOptions };
          }

          return control;
        });
        view.lanes = view.lanes.map((lane) => {
          lane.controls = lane.controls.map((control) => {
            if (changeSetIds?.includes(control.id) || !changeSetIds) {
              return { ...control, ...changedOptions };
            }

            return control;
          });
          return lane;
        });
      })
    );
  }
}
